<template>
	<div>
		<table class="table table-hover">
			<thead>
				<tr>
					<th>Ip-adres</th>
					<th>Email</th>
					<th>Poging</th>
					<th>Dag - Tijd</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(message, index) in messages" :key="index">
					<td>{{ message.ip }}</td>
					<td>{{ message.email }}</td>
					<td v-if="message.attempt==5">Banned</td>
					<td v-else>{{ message.attempt }}</td>
					<td>{{ message.dateNl }}</td>
				</tr>
			</tbody>
		</table>

		<div class="row mb-5">
			<div class="col-12 text-center p-3 mt-3 mb-5">
				<nav aria-label="pagination">
					<ul class="pagination justify-content-center mt-3">
						<li class="page-item" :class="{'disabled': page.first == page.current}">
							<a class="page-link" href="#berichten" @click="goToPage(page.first)">Eerste</a>
						</li>
						<li class="page-item" :class="{'disabled': page.current -1 <= 0}">
							<a class="page-link" href="#berichten" @click="goToPage(page.current-1)">Vorige</a>
						</li>
						<li class="page-item" v-for="n in page.num" :key="n" :class="{'active':n==page.current}">
							<a 	class="page-link" 
								href="#berichten" 
								@click="goToPage(n)" 
							>{{ n }}</a>
						</li>
						
						<li class="page-item" :class="{'disabled': page.current >= page.last}">
							<a class="page-link" href="#berichten" @click="goToPage(page.current+1)">Volgende</a>
						</li>
						
						<li class="page-item" :class="{'disabled': page.last == page.current}">
							<a class="page-link" href="#berichten" @click="goToPage(page.last)" >Laatste</a>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</div>

</template>

<script>
export default {

	name: 'loginlog',

	data () {
	return {
			messages : [],
			pagination:{
				'current' 	: 1,
				'first'		: 1,
				'last'		: 1,
				'num'		: 1,
			}
		}
	},
	computed:{
		page : function(){
			return this.pagination;
		}
	},
	methods : 	{
		goToPage : 	function(num){
						this.pagination.current=num;

						this.$store.dispatch("get",this.$store.state.endpoint+'loginlogs?page='+this.pagination.current+'&token='+this.$store.state.token)
					    .then(data=>{  
					        this.messages=data.data.data;
					       	this.pagination.num 	= data.data.meta.last_page;
					       	this.pagination.first = 1;
					       	this.pagination.last 	= data.data.meta.last_page;
					       	// window.console.log('data',data);
					    }) 
					    .catch(error=>{
					        if(error.request.status == 401){
					            this.error=true;
					            this.error_msg="invalid login details";
					        }
					        // window.console.log(error.request.response);
					        
					    });
						// console.log('pagina',num);
					}
  	},
  	created(){
		this.$store.dispatch("get", this.$store.state.endpoint+'loginlogs?page=1&token='+this.$store.state.token)
	    .then(data=>{  
	        this.messages=data.data.data;
	       	this.pagination.num 	= data.data.meta.last_page;
	       	this.pagination.first = 1;
	       	this.pagination.last 	= data.data.meta.last_page;
	       	// window.console.log('data',data);
	    }) 
	    .catch(error=>{
	        if(error.request.status == 401){
	            this.error=true;
	            this.error_msg="invalid login details";
	        }
	        // window.console.log(error.request.response);
	        
	    });
	}
}
</script>

<style lang="css" scoped>
</style>